import { registerGlobalActions } from '@shared/global-actions/action'

export const bootstrapGlobalActionsClient = async () => {
  registerGlobalActions()
}
